import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { heroSlides } from '../../data/homeContent';
import { bannerImages } from '../../data/bannerImages';

function HighlightTitle({ title, highlight }) {
  if (!highlight || !title.toLowerCase().includes(highlight.toLowerCase())) {
    return title;
  }
  const start = title.toLowerCase().indexOf(highlight.toLowerCase());
  const before = title.slice(0, start);
  const match = title.slice(start, start + highlight.length);
  const after = title.slice(start + highlight.length);
  return (
    <>
      {before}
      <em>{match}</em>
      {after}
    </>
  );
}

function HomeHero() {
  const [index, setIndex] = useState(0);
  const slide = heroSlides[index];

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((current) => (current + 1) % heroSlides.length);
    }, 7000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className={`home-hero home-hero-${slide.theme}`}>
      <div className="home-hero-shape home-hero-shape-a" />
      <div className="home-hero-shape home-hero-shape-b" />
      <div className="container home-hero-inner">
        <div className="home-hero-dots" role="tablist" aria-label="Hero slides">
          {heroSlides.map((item, i) => (
            <button
              key={item.kicker}
              type="button"
              className={i === index ? 'is-active' : ''}
              aria-label={item.kicker}
              onClick={() => setIndex(i)}
            />
          ))}
        </div>

        <div className="home-hero-copy">
          <p className="home-kicker">{slide.kicker}</p>
          <h1>
            <HighlightTitle title={slide.title} highlight={slide.highlight} />
          </h1>
          <p className="home-hero-text">{slide.text}</p>
          <ul className="home-hero-points">
            {slide.points.map((point) => (
              <li key={point}>{point}</li>
            ))}
          </ul>
          <div className="home-hero-actions">
            <Link to={slide.primary.to} className="home-btn home-btn-primary">
              {slide.primary.label}
            </Link>
            <Link to={slide.secondary.to} className="home-btn home-btn-ghost">
              {slide.secondary.label}
            </Link>
          </div>
        </div>

        <div className="home-hero-panel">
          <div className="home-hero-visual">
            <div className="home-chip-row">
              <span>Learn</span>
              <span>Score</span>
              <span>Grow</span>
            </div>
            <div className="home-hero-photo">
              <img src={bannerImages[slide.theme]} alt={slide.title} />
              <div className="home-hero-float">
                <span className="home-hero-badge">{slide.badge.value}</span>
                <p>{slide.badge.label}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HomeHero;
